import PushPinIcon from '@mui/icons-material/PushPin';
import { Button, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { TournamentStatus } from '@okletsplay/core';
import React, { FC, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import { updateTrackedBy } from 'modules/tournaments/store/current-tournament/repository';
import { withTournamentStatus } from '../../HOC/withTournamentStatus';

export const TrackButtonComponent: FC = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const myTeam = useSelector(currentTournamentSelector.myTeam);
  const isTournamentTracked = useSelector(currentTournamentSelector.isTournamentTracked);
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const tournament = useSelector(currentTournamentSelector.tournament);

  const title = useMemo(() => (!isTournamentTracked ? 'Track' : 'Tracked'), [isTournamentTracked]);

  const onClickHandler = useCallback(() => {
    if (!tournament.id) {
      return;
    }

    dispatch(updateTrackedBy(tournament.id));
  }, [dispatch, tournament.id]);

  if (!myTeam) {
    return null;
  }

  if (isLargeScreen) {
    return (
      <Button
        size="medium"
        onClick={onClickHandler}
        disabled={isTournamentTracked}
        sx={{ color: theme.palette.text.primary }}
        startIcon={<PushPinIcon fontSize="medium" />}
      >
        {title}
      </Button>
    );
  }

  return (
    <IconButton
      aria-label="share"
      onClick={onClickHandler}
      sx={{ color: theme.palette.text.primary }}
    >
      <PushPinIcon fontSize="medium" />
    </IconButton>
  );
};

export const TrackButton = withTournamentStatus(TrackButtonComponent, [
  TournamentStatus.Pending,
  TournamentStatus.Live,
  TournamentStatus.Checkin,
]);
